import { render } from "./ConfirmRejectApplicationDialog.vue?vue&type=template&id=48b601cf"
import script from "./ConfirmRejectApplicationDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmRejectApplicationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__